import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { texts, images } from '../../settings';
import { Actions } from '../../flux';
//Components
import {  DelayLink } from '../../components';
import { Fade, Zoom } from 'react-reveal/';
import { SliderLetras } from '../../components/SliderLetras';
import { GraficoPerfil } from '../../components/GraficoPerfil';
import { Comunicacao } from '../../components/Comunicacao';
import { Hero } from '../../components/Hero';
import { MapaBrasil } from '../../components/MapaBrasil';

//JSON
import ListaAssociados from "../../static/json/ListaAssociados.json";

import "./Associados.scss";

class Associados extends Component {
  constructor(props) {
    super(props)
    this.state = {
      perfilAssociados: false,
    }
    this.texts = texts;

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  }
  
  render = () => {
    return (
      <div className="views views--associados" ref={this.contentText}>
        <Helmet>
          <title>{this.texts.title}</title>
        </Helmet>
        <Hero
          estilo="heroDefault"
          titulo="Associados"
          subtitulo="Os associados são nossa razão de existir: fechamos o ano com 265 instituições, entre bancos comerciais, múltiplos, de investimento, corretoras, distribuidoras e gestoras."
          gri="102-6, 102-7"
          imagem={images.associados.associadosCasas}
          background={images.associados.bgAssociados}
        />
        <GraficoPerfil />
        <MapaBrasil />
        <Fade>
          <div className="container container-entenda">
            <div className="row">
              <div className="box-pill box-pill--yellow box-pill--center">
                <div className="box-pill__content box-pill__content--full">
                  <div className="row">
                    <div className="col col-1 col--image">
                      <img src={images.associados.papelGrafico} className="pessoa_destaque pessoa_destaque--top pessoa_destaque--1" />
                    </div>
                    <div className="col col-10 col--text col--text--center">
                      <h4>Estrutura de representação de 2019</h4>
                      <DelayLink
                        to="/governanca-corporativa/organismos-de-representacao"
                        className="button button--aylen button--white-to-yellow button--border-medium button--size-m button--round-l button--text-thick"
                      >
                        Saiba mais
                      </DelayLink>
                    </div>
                    <div className="col col-1 col--image">
                      <img src={images.associados.papelLupa} className="pessoa_destaque pessoa_destaque--bottom pessoa_destaque--right pessoa_destaque--2" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fade>

        <Comunicacao />

        <Hero
          estilo=""
          background={images.associados.bgAssociados}
        />

        <div className="associados-nome">
          <Zoom>
            <h3 className="associados-nome__titulo">Vamos conhecer os associados?</h3>
          </Zoom>
          <p className="associados-nome__texto">
            <span className="gri_text">
              Confira abaixo a lista completa de instituições que fazem parte da ANBIMA:
              <span className="gri_label blue">GRI <b>102-40</b></span>
            </span>
          </p>
          <SliderLetras data={ListaAssociados}/>
        </div>

        <Fade>
          <div className="container box-footer">
            <div className="row">
              <div className="box-pill box-pill--green box-pill--center">
                <div className="box-pill__content box-pill__content--full">
                  <div className="row">
                    <div className="col col-10 col--text col--text--center">
                      <h4>Entenda como é formado o nosso Conselho de Ética</h4>
                      <DelayLink
                        to="/governanca-corporativa/conselho-de-etica"
                        className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick"
                      >
                        Saiba mais
                      </DelayLink>
                    </div>
                    <div className="col col-2 col--image">
                      <img src={images.associados.personagemConselho} className="pessoa_destaque pessoa_destaque--bottom pessoa_destaque--right pessoa_destaque--2" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fade>

      </div>
    )
  }
}

export { Associados }